let g_API_BASE_URL = "";
let g_UI_BASE_URL = "";

if (process.env.NODE_ENV === "development") {
  let devHost = process.env.VUE_APP_DEV_HOST;
  if (process.env.MODE_TYPE === "1") {
    devHost = process.env.VUE_APP_t_DEV_HOST;
  }
  g_API_BASE_URL = process.env.VUE_APP_g_UI_BASE_URL;
  g_UI_BASE_URL = "http://" + devHost + ":3000";
} else {
  g_API_BASE_URL = process.env.VUE_APP_API_BASE_URL;
  g_UI_BASE_URL = process.env.VUE_APP_BASE_URL;
}

// export const API_BASE_URL = g_API_BASE_URL;
export const API_BASE_URL = g_API_BASE_URL;

export const UI_BASE_URL = g_API_BASE_URL;

let sUserAgent = navigator.userAgent.toLowerCase();
let bIsIpad = sUserAgent.match(/ipad/i) == "ipad";
let bIsIphoneOs = sUserAgent.match(/iphone os/i) == "iphone os";
let bIsMidp = sUserAgent.match(/midp/i) == "midp";
let bIsUc7 = sUserAgent.match(/rv:1.2.3.4/i) == "rv:1.2.3.4";
let bIsUc = sUserAgent.match(/ucweb/i) == "ucweb";
let bIsAndroid = sUserAgent.match(/android/i) == "android";
let bIsCE = sUserAgent.match(/windows ce/i) == "windows ce";
let bIsWM = sUserAgent.match(/windows mobile/i) == "windows mobile";
let bIsTablet = sUserAgent.match(/tablet/i) == "tablet";
let bIsGoolgeBotMobile =
  sUserAgent.match(/Goolgebot/i) == "Goolgebot" &&
  (sUserAgent.match(/Mobile/i) ||
    "Mobile" ||
    sUserAgent.match(/Android/i) == "Android" ||
    sUserAgent.match(/AppleWebKit/i)) == "AppleWebKit";
let bIsMiui = /miuibrowser|xiaomi\/miuibrowser/.test(sUserAgent);
let bIsQQ = /qqbrowser|mqqbrowser/.test(sUserAgent);
let bIsVivo = /vivo/.test(sUserAgent);

let device = {};
if (bIsIphoneOs) device.isApple = true;
let isMobile =
  (bIsIphoneOs ||
    bIsMidp ||
    bIsUc7 ||
    bIsUc ||
    bIsAndroid ||
    bIsCE ||
    bIsWM ||
    bIsGoolgeBotMobile) &&
  !bIsTablet;
let isPad = bIsIpad || bIsTablet;
if (!isMobile && !isPad) {
  device.isPC = true;
} else if (isPad) {
  device.isPad = true;
} else {
  device.isMobile = true;
}
if (bIsMiui || bIsQQ) {
  device.isMIorQQ = true;
}
if (bIsVivo) {
  device.isVivo = true;
}

export const DEVICE_TYPE = device;

// 区分正式服测试服预发布域名以及对应的cos

let serverEnv = "";
switch (window.location.host) {
  case "cloudgame-br.qcloud.com":
    serverEnv = "https://cdn.cloudgame-br.qcloud.com";
    break;
  case "xgame.qcloud.com":
    serverEnv =
      "https://ct-global-dev-cd-1300343054.cos.ap-chengdu.myqcloud.com";
    break;
  case "cloudgame-test.gameexp.com":
    serverEnv =
      "https://ct-global-dev-1300343054.cos.ap-singapore.myqcloud.com";
    break;
  case "cloudgame.qcloud.com":
    serverEnv = "https://cdn.cloudgame.qcloud.com";
    break;
  default:
    serverEnv =
      "https://ct-global-dev-1300343054.cos.ap-singapore.myqcloud.com";
    break;
}

export const COSADDR = serverEnv;

export function CheckImgExistsH5(name, gameId, url) {
  return new Promise(function (resolve, reject) {
    // if (isCustomH5) {
    const ImgObj2 = new Image();
    ImgObj2.src =
      COSADDR + "/game/assets-h5/" + gameId + "-H5/" + name + ".png";
    console.log(COSADDR + "/game/assets-h5/" + gameId + "-H5/" + name + ".png");
    ImgObj2.onload = function () {
      resolve(
        "url('" +
          COSADDR +
          "/game/assets-h5/" +
          gameId +
          "-H5/" +
          name +
          ".png" +
          "')"
      );
    };
    ImgObj2.onerror = function () {
      // isCustomH5 = false;
      const ImgObj = new Image();
      ImgObj.src = COSADDR + "/game/assets-default/" + name + ".png";
      ImgObj.onload = function () {
        resolve(getDefaultCosAddress(name, gameId));
      };
      ImgObj.onerror = function () {
        reject("");
      };
    };
    // } else {
    //   const ImgObjDefault = new Image();
    //   ImgObjDefault.src = COSADDR + "/game/assets-default/" + name + ".png";
    //   ImgObjDefault.onload = function () {
    //     resolve(getDefaultCosAddress(name, gameId));
    //   };
    // }
  });
}

// 获取自定义icon cos地址 H5
export function getCosH5Address(name, gameId) {
  // return ImageIsExist(name, gameId, getSrcCosAddressH5(name, gameId));
  return CheckImgExistsH5(name, gameId, getSrcCosAddressH5(name, gameId));
}

// 获取自定义icon cos地址 H5
export function getSrcCosAddressH5(name, gameId) {
  return COSADDR + "/game/assets-h5/" + gameId + "-H5/" + name + ".png";
}

// 获取默认icon cos地址
export function getDefaultCosAddress(name, gameId) {
  return "url('" + COSADDR + "/game/assets-default/" + name + ".png')";
}

export const GameThemeColor = {
  "8bd999": "#7e7bfc",
  545007: "#8296b3",
  "2l56r5": "#8296b3",
  bbg7bb: "rgb(34,122,181)",
  "60989g": "#bc6b1d",
};

export const GameBackgroundColor = {
  "8bd999": "#464450",
  545007: "#404a5f",
  "2l56r5": "#404a5f",
  bbg7bb: "#464450",
};

export const GameConfirmColor = {
  "8bd999": "#523fff",
  545007: "#62c1b6",
  "2l56r5": "#62c1b6",
  bbg7bb: "#523fff",
};

export const GameTextColor = {
  "60989g": "#5f5952",
};

export function notEmpty(value) {
  return (
    value !== "undefined" &&
    value !== undefined &&
    value !== null &&
    value !== ""
  );
}

let isProd = false;
let host = window.location.hostname;
if (host == 'cloudgame-br.qcloud.com') {
  isProd = true;
}
export const isProdEnv = isProd;